module.exports = __webpack_public_path__ + "static/posterFeatures-38c899a691dd03ae1e5ba51ddeaff294.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/enterprise/posterFeatures.jpg
// module id = 2571
// module chunks = 168707334958949